<!-- ll-standards-ignore LL008 -- presentational only; its logic is one ternary, asserted
     through ApproveAgentDialog.spec.ts which renders it. -->
<template>
  <div class="bg-grey-lighten-4 rounded p-3" data-cy="agent-identity">
    <div class="font-weight-medium">{{ agent.name }}</div>
    <div class="text-caption text-grey-darken-1 mt-1">{{ agent.origin }}</div>
    <div class="mt-2">
      <LlStatusBadge :tone="agent.isVerifiedPublisher ? 'green' : 'amber'">
        {{ agent.isVerifiedPublisher ? 'Verified' : 'Unverified' }}
      </LlStatusBadge>
    </div>
    <p v-if="!agent.isVerifiedPublisher" class="text-caption text-amber-darken-4 mt-2 mb-0" data-cy="unverified-warning">
      LeanLaw has not verified this agent. Its name and address were chosen by whoever registered it, so it can
      claim to be anyone. Approve it only if you know where it came from.
    </p>
    <div v-if="agent.redirectUris?.length" class="mt-2" data-cy="agent-redirect-uris">
      <div class="text-caption text-grey-darken-1">It can send people's approvals to:</div>
      <ul class="ml-4 mb-0 text-caption">
        <li v-for="uri in agent.redirectUris" :key="uri" class="text-break">{{ uri }}</li>
      </ul>
    </div>
    <p v-if="isCopilotStudio" class="text-caption text-grey-darken-1 mt-2 mb-0" data-cy="copilot-studio-note">
      Approving Copilot Studio lets any Copilot Studio connector reach your firm's sign-in screen. Each person
      still signs in to LeanLaw and approves their own permissions.
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import LlStatusBadge from '@/components/LlStatusBadge.vue';
import { COPILOT_STUDIO_CLIENT_ID, type AgentAccessAgent } from '../models/agentAccessTypes';

// For a verified agent LeanLaw established both the name and the address. For an unverified one the
// registrant typed both, which is why the warning says so rather than pointing at the address.
const props = defineProps<{ agent: AgentAccessAgent }>();

const isCopilotStudio = computed(() => props.agent.clientId === COPILOT_STUDIO_CLIENT_ID);
</script>
